module.exports = __webpack_public_path__ + "static/media/Earth_Badge.3f8f90d8.png";